import axios from 'axios';
import store from '@/store';
import router from '@/router';

const service = axios.create({});

service.interceptors.response.use(
    // eslint-disable-next-line no-undefined
    undefined,
    error => {
        if (error.response.status === 401 || error.response.status === 403
        // && error.response.data.message.indexOf('JWT expired') > -1
        ) {
            store.dispatch('auth/logout');
            router.push({ path: '/login' }).catch(innerError => {
                console.error('NOTA:', innerError.message);
            });
        }
        console.log(error.response);
        return Promise.reject(error);
    }
);

export default service;
